// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import DebitItem from '@deere/cps-it.warranty-model-factory/lib/partial-debit';
import EditableField from '../../../../shared/components/editable-field';
import FormattedNumberInput from '../../../../shared/components/formatted-number-input';
import KeyValueDropDown from '../../../../claim/shared/components/claim-fields/key-value-dropdown';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import {getAmountWithCurrency} from '../../services/partial-debit-helper';

function handleAdjustmentValueChange(value) {

    this.onAdjustmentValueChange(value);

}

function handleAdjustmentTypeChange(event) {

    this.onAdjustmentTypeChange(event.target.value);

}

const DebitPartsPanelRowBody = props =>
    <section className='debit-parts-panel-row-body'>
        <span className='description'>{`${props.part.material} - ${props.part.description}`}</span>
        <span className='unit'>{props.part.unit.value}</span>
        <span className='amount'>{getAmountWithCurrency(props.part.amount, props.part.currency)}</span>
        <span className='quantity'>{props.part.quantity}</span>
        <EditableField
            className='adjustment-type'
            isEditable={props.isEditable}
            value={props.part.adjustmentType.value}
        >
            <KeyValueDropDown
                className='adjustment-type'
                list={props.adjustmentTypes}
                onChange={props::handleAdjustmentTypeChange}
                showBlankOption={false}
                value={props.part.adjustmentType.key}
            />
        </EditableField>
        <EditableField
            className='value-of-adjustment'
            isEditable={props.isEditable && props.part.adjustmentType.key !== '01'}
            value={props.part.adjustmentType.key === 'AMOUNT' ? getAmountWithCurrency(props.part.valueOfAdjustment, props.part.currency) : props.part.valueOfAdjustment}
        >
            <FormattedNumberInput
                allowNegative={false}
                className='value-of-adjustment'
                decimalPrecision={2}
                onValueChange={props::handleAdjustmentValueChange}
                value={props.part.valueOfAdjustment}
            />
        </EditableField>
    </section>;

DebitPartsPanelRowBody.displayName = 'DebitPartsPanelRowBody';
DebitPartsPanelRowBody.propTypes = {
    adjustmentTypes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)),
    isEditable: PropTypes.bool.isRequired,
    onAdjustmentTypeChange: PropTypes.func,
    onAdjustmentValueChange: PropTypes.func,
    part: PropTypes.instanceOf(DebitItem).isRequired
};

export default DebitPartsPanelRowBody;



// WEBPACK FOOTER //
// ./src/tcsm/partial-debit/components/debit-parts-panel/debit-parts-panel-row-body.js